/**
 * site specific config
 * Created by maktarh on 30/03/2017.
 */
(function () {
    "use strict";

    /**
     * Should have a function called getSiteConfig that returns an object with report suites and tracking domain
     * @constructor
     */
    function NadexSitecatConfig() {

    }

    /**
     * Gets the report suite and tracking domain for dfx sites
     * @returns {{mainReportSuite: *, rollupReportSuite: string, trackingDomain: *}}
     */
    NadexSitecatConfig.prototype.getSiteConfig = function (mockWindow) {
        var windowContext = mockWindow || window;
        var url = windowContext.location.href;
        var lang = document.documentElement.lang.toLowerCase();
        var mainReportSuite;
        var rollupReportSuite = '';
        var trackingDomain;

        var organisationId = "434717FE52A6476F0A490D4C@AdobeOrg";

        trackingDomain = "ig.nadex.com";
        mainReportSuite = 'adviggroupnadexlive';
        rollupReportSuite = 'adviggrouprollup';

        if (window.nadex.marketing.analytics.environment.determineEnvironment() !== 'prod') {
            mainReportSuite = 'adviggroupnadextest';
            rollupReportSuite = '';
        }

        console.log("nadex analytics: ", mainReportSuite, trackingDomain, organisationId);

        return {
            mainReportSuite: mainReportSuite,
            rollupReportSuite: rollupReportSuite,
            trackingDomain: trackingDomain,
            organisationId: organisationId
        }

    };
    window.nadex = window.nadex || {};
    window.nadex.marketing = window.nadex.marketing || {};
    window.nadex.marketing.analytics = window.nadex.marketing.analytics || {};
    window.nadex.marketing.analytics.sitecatConfig = new NadexSitecatConfig();
}());